import { render, staticRenderFns } from "./ContabilidadScreenReportes.vue?vue&type=template&id=220cbc3e&scoped=true"
import script from "./ContabilidadScreenReportes.vue?vue&type=script&lang=js"
export * from "./ContabilidadScreenReportes.vue?vue&type=script&lang=js"
import style0 from "./ContabilidadScreenReportes.vue?vue&type=style&index=0&id=220cbc3e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "220cbc3e",
  null
  
)

export default component.exports